import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import app from 'flarum/forum/app';
import Button from 'flarum/common/components/Button';
const t = (k, p) => app.translator.trans('ernestdefoe-calendar.forum.' + k, p);
const pad = n => String(n).padStart(2, '0');

/**
 * Self-service birthday picker for the account settings page. Stores only month +
 * day (MM-DD) — never a year — so celebrating a birthday can't reveal someone's
 * age. Saving an empty selection clears it (fully opt-in / opt-out).
 */
const BirthdayField = {
  oninit() {
    const v = String(app.session.user && app.session.user.attribute('calendarBirthday') || '');
    const _v$split = v.split('-'),
      _v$split2 = _slicedToArray(_v$split, 2),
      mm = _v$split2[0],
      dd = _v$split2[1];
    this.mm = mm || '';
    this.dd = dd || '';
    this.saving = false;
  },
  view() {
    var _app$session$user;
    const months = Array.from({
      length: 12
    }, (_, i) => ({
      v: pad(i + 1),
      label: new Date(2000, i, 1).toLocaleDateString(undefined, {
        month: 'long'
      })
    }));
    const days = Array.from({
      length: 31
    }, (_, i) => pad(i + 1));
    const dirty = this.mm + '-' + this.dd !== String(((_app$session$user = app.session.user) == null ? void 0 : _app$session$user.attribute('calendarBirthday')) || '-');
    return m('.CalBirthday', [m('p.helpText', t('birthday_help')), m('.CalBirthday-row', [m('select.FormControl.CalBirthday-month', {
      value: this.mm,
      onchange: e => this.mm = e.target.value
    }, [m('option', {
      value: ''
    }, t('birthday_month')), ...months.map(mo => m('option', {
      value: mo.v
    }, mo.label))]), m('select.FormControl.CalBirthday-day', {
      value: this.dd,
      onchange: e => this.dd = e.target.value
    }, [m('option', {
      value: ''
    }, t('birthday_day')), ...days.map(d => m('option', {
      value: d
    }, d))]), Button.component({
      className: 'Button',
      loading: this.saving,
      disabled: !dirty || !!this.mm !== !!this.dd,
      onclick: () => this.save()
    }, t('birthday_save'))])]);
  },
  save() {
    const user = app.session.user;
    if (!user) return;
    const value = this.mm && this.dd ? this.mm + '-' + this.dd : null;
    this.saving = true;
    m.redraw();
    user.save({
      calendarBirthday: value
    }).then(() => {
      this.saving = false;
      app.alerts.show({
        type: 'success'
      }, t('birthday_saved'));
      m.redraw();
    }).catch(() => {
      this.saving = false;
      m.redraw();
    });
  }
};
export default BirthdayField;
flarum.reg.add('ernestdefoe-calendar', 'forum/components/BirthdayField', BirthdayField);